import { PROPERTY, IProperty, Property } from '@clooper/core';
import { Pipe, PipeTransform } from '@angular/core';
/**
  * PropertyDisplayNamePipe
  *
  * A pipe to construct the display name of a property.
  */
@Pipe({ name: 'displayName' })
export class PropertyDisplayNamePipe implements PipeTransform {
  /**
  * Constructs a display name for the passed in property
  * @param {IProperty|Property} property A property Object.
  * @return {string} Returns a constructed display name.
  */
  transform(property: IProperty | Property): string {
    const { OCCUPANCY_TYPES } = PROPERTY;
    const occupancy = property.occupancy_type === OCCUPANCY_TYPES.SHARED ? 'Shared' : '';
    const bedrooms = property.total_rooms !== undefined ? `${property.total_rooms} bedroom` : '';
    return `${occupancy} ${bedrooms} ${property.property_type_name} at ${property.address.street} ${property.address.city}`.trim()
  }
}
